export const CURRENCY_VALUE_FRAGMENT = `{
  symbol
  code
  available
  pendingDeposit
  pendingWithdrawal
  redeemed
  redeemMultiplier
}`
